export const generateRandomKey = (keyLength) => {
    // This gives an 11 char random alpha numeric string
    let startRandomStr = Math.random().toString(36).slice(2);

    while (startRandomStr.length < keyLength){
        startRandomStr += Math.random().toString(36).slice(2)
    }

    return startRandomStr.substring(0, keyLength)
}